import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { StepperComponent } from './stepper.component';

@NgModule({
  imports: [CommonModule, CdkStepperModule, MatRippleModule],
  exports: [StepperComponent, CdkStepperModule],
  declarations: [StepperComponent],
  providers: []
})
export class StepperModule {}
